import { rsvpConstants as rc } from './constants'

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null
}

export function rsvp(state = initialState, action) {
  switch (action.type) {
    case rc.UPDATE_ATTENDANCE_REQUEST: {
      return {
        ...state,
        loading: true,
        success: false
      }
    }
    case rc.UPDATE_ATTENDANCE_SUCCESS: {
      const { mixrId, recurrenceAttending } = action
      return {
        ...state,
        loading: false,
        success: true,
        data: { mixr_id: mixrId, ...action.response, recurrence_mixr_attending: recurrenceAttending }
      }
    }

    case rc.UPDATE_ATTENDANCE_FAILURE: {
      return {
        ...state,
        error: action.error,
        success: false,
        loading: false,
        data: null
      }
    }

    case rc.REJECT_INVITATION_REQUEST: {
      return {
        ...state,
        loading: true,
        success: false
      }
    }
    case rc.REJECT_INVITATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        data: {
          mixr_id: action?.response?.mixr_id,
          user_id: action?.response?.user_id,
          attending: 'none'
        }
      }
    }

    case rc.REJECT_INVITATION_FAILURE: {
      return {
        ...state,
        error: action.error,
        success: false,
        loading: false,
        data: null
      }
    }

    case rc.CLEAR_DATA: {
      return initialState
    }

    default:
      return state
  }
}
